<mat-spinner test-id="open-id-connect-container" diameter="20"></mat-spinner>
<ng-container *ngIf="oidcProvider">
	<p>{{ "login.type." + oidcProvider + ".authenticating" | translate }}</p>
	<p>{{ "login.type." + oidcProvider + ".authenticating.wait" | translate }}</p>
</ng-container>
